import api from '../token';

export const AddVeiculo = async (dados) => {
  try {
    const response = await api.post('/addVeiculo', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};
